import { Link } from 'react-router-dom';

const footerLinks = {
  分类浏览: [
    { name: '甜宠小说', path: '/category/tianchong' },
    { name: '萌系小说', path: '/category/mengxi' },
    { name: '治愈系小说', path: '/category/zhiyu' },
    { name: '校园小说', path: '/category/xiaoyuan' },
    { name: '奇幻小说', path: '/category/qihuan' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '口碑评价', path: '/about' },
  ],
  推荐阅读: [
    { name: '热门书单', path: '/' },
    { name: '最新推荐', path: '/' },
    { name: '精选合集', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-accent-100/40 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading text-foreground-950">
                可爱小说推荐
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选最萌治愈系小说合集，涵盖甜宠、萌系、治愈系等多种风格，陪你度过每一个温柔时光。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-10 pt-6 border-t border-background-200/60 gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 可爱小说推荐 - 最萌治愈系小说合集。本站为小说推荐平台，所有内容仅供阅读推荐。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}